import { VisuallyHidden } from '@reach/visually-hidden';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faAsterisk, faCheck, faQuestion, faTimes } from '@fortawesome/free-solid-svg-icons';

import style from './LeftNav.module.css';

const LeftNavItem = ({ item, onClick }) => {
  if (item.isCurrent === true) {
    return (
      <li tabIndex="-1">
        <span className={style.Current}>
          <VisuallyHidden>This is the current step</VisuallyHidden>
          <FontAwesomeIcon icon={faAsterisk} />
          {item.displayName}
        </span>
      </li>
    );
  } else if (item.isComplete === true) {
    return (
      <li tabIndex="-1" onClick={() => { onClick(item.path) }}>
        <span className={style.Complete}>
          <VisuallyHidden>This step is complete</VisuallyHidden>
          <FontAwesomeIcon icon={faCheck} />
          {item.displayName}
        </span>
      </li>
    );
  } else if (item.isVisited === true && item.isComplete !== true) {
    return (
      <li tabIndex="-1" onClick={() => { onClick(item.path) }}>
        <span className={style.Incomplete}>
          <VisuallyHidden>This step is started, but not complete</VisuallyHidden>
          <FontAwesomeIcon icon={faQuestion} />
          {item.displayName}
        </span>
      </li>
    );
  } else if (item.isVisited !== true && item.arePrerequisitesDone === true) {
    return (
      <li tabIndex="-1" onClick={() => { onClick(item.path) }}>
        <span className={style.NotStarted}>
          <VisuallyHidden>This step is not started yet, but is currently available</VisuallyHidden>
          <FontAwesomeIcon icon={faCircle} className={style.InvisibleIcon} />
          {item.displayName}
        </span>
      </li>
    );
  } else {
    return (
      <li tabIndex="-1">
        <span className={style.NotAllowed}>
          <VisuallyHidden>This step is currently unavailable</VisuallyHidden>
          <div>
            <FontAwesomeIcon icon={faTimes} />
            {item.displayName}
          </div>
          <div className={style.NotAllowedNote}>(complete other steps first)</div>
        </span>
      </li>
    );
  }
};

export default LeftNavItem;